import {
  EventCalendar,
  EventCalendarTicketEntry,
  EventReservedTickets,
  ITaxRate,
} from 'app/pages/TicketSalePage/slice/types';
import { DateTime } from 'luxon';
import { TicketPrice } from 'types/TicketsState';
import { dateFormatForCalendar, getTimetableForTicket } from 'utils/calendar';
import { getTaxPrice } from 'utils/tickets';

export const getPricePaidForASingleTicket = (
  prices: TicketPrice[],
  taxRate: ITaxRate,
  tax_included: boolean,
) => {
  const firstTicketOption = prices[0];
  let thePricePaidForASingleTicket = firstTicketOption?.price;
  const theTaxPaidForASingleTicket = getTaxPrice(
    firstTicketOption?.price,
    taxRate.rate,
  );

  if (tax_included) {
    thePricePaidForASingleTicket += theTaxPaidForASingleTicket;
  }

  return thePricePaidForASingleTicket;
};

export const getTicketAvailabilityDefault = (
  limit: number | null,
  maxOrderQuantity: number,
) => {
  if (limit === null) return maxOrderQuantity;
  return Math.min(limit, maxOrderQuantity);
};

export const getTicketAvailabilityOnCalendar = (
  calendar: EventCalendar,
  reservedTickets: EventReservedTickets,
  ticketTypeId: string,
  day: DateTime,
): number => {
  const { limit, maxOrderQuantity } = getTimetableForTicket(
    calendar,
    day,
    ticketTypeId,
  ) as EventCalendarTicketEntry;

  if (limit === null) return maxOrderQuantity;

  const reservedQuantity =
    reservedTickets[ticketTypeId]?.[day.toFormat(dateFormatForCalendar)];

  if (reservedQuantity === undefined) return Math.min(limit, maxOrderQuantity);

  return Math.min(limit - reservedQuantity, maxOrderQuantity);
};

export const getTicketLimitOnCalendar = (
  calendar: EventCalendar,
  reservedTickets: EventReservedTickets,
  ticketTypeId: string,
  day: DateTime,
) => {
  const { limit } = getTimetableForTicket(
    calendar,
    day,
    ticketTypeId,
  ) as EventCalendarTicketEntry;

  if (limit === null) return null;

  const reservedQuantity =
    reservedTickets[ticketTypeId]?.[day.toFormat(dateFormatForCalendar)];

  if (reservedQuantity === undefined) return limit;

  return limit - reservedQuantity;
};
